import React, { FC } from 'react';
import { GenericPage } from '../../../app/pages/ui/GenericPage';
import { useSetFlightsEnrichmentData } from '../../shared/flight/ui/useSetFlightsEnrichmentData';
import { IFlightsPageData } from '../domain/models/IFlightsPageData';
import { FlightsOverview } from './FlightsOverview';

interface IFlightsPageProps extends IFlightsPageData {}

export const FlightsPage: FC<IFlightsPageProps> = ({
	page,
	flightsEnrichmentData,
}) => {
	useSetFlightsEnrichmentData(flightsEnrichmentData);

	return (
		<GenericPage page={page} overlapContentWithHeader>
			<FlightsOverview />
		</GenericPage>
	);
};
